<h2>About</h2>

<p>Tasks provides a one stop shop to request new services and resolve tasks assigned to you.</p>

<p>
  Built by and copyright KnowProcess, this application is available under the
  <a href="{{env.contentLinks.licence}}" rel="licence">{{env.contentLinks.licenceText}}</a>.
</p>
<p>
  To make services consistent with GOV.UK and benefit from the research and experience of public service teams it employs the
  <a href="https://design-system.service.gov.uk/">GOV.UK design system</a>, which is licensed under the
  <a href="https://www.nationalarchives.gov.uk/information-management/re-using-public-sector-information/uk-government-licensing-framework/crown-copyright/">Open Government Licence v3.0</a>.
</p>

<p>
  Version: <span class="govuk-!-font-weight-bold">{{env.version}}</span>
</p>
